import { useFlag } from '@acre/utils'

const PREVIEW_MODE_HOST = 'crm-next'
const CRM_HOST_PREFIX = /^crm(-next)?\./

/**
 * Preview mode is the same app served from the `crm-next` host of whichever domain the user
 * is already on, so the toggle swaps that prefix and keeps the rest of the hostname.
 */
export const buildPreviewModeUrl = ({
  hostname,
  pathname,
  enable,
}: {
  hostname: string
  pathname: string
  enable: boolean
}) => {
  const targetHost = hostname.replace(CRM_HOST_PREFIX, `${enable ? PREVIEW_MODE_HOST : 'crm'}.`)

  return `https://${targetHost}${pathname}`
}

const usePreviewMode = () => {
  return {
    allowed: useFlag('feature.preview_mode', true),
    active: window.location.hostname.includes(PREVIEW_MODE_HOST),
  }
}

export default usePreviewMode
